import React from 'react';
import './Icaim27.css';
import Navbar from '../../components/navbar';
import PageHeader from '../../about/PageHeader';
import Footer from '../../components/Footer';

const Icaim27 = () => {
  return (
    <>
      <Navbar />
      
      {/* Header Area with Background pattern hooks */}
      <div className="icaim27-header-wrapper">
        <div className="icaim27-dot-pattern top-left"></div>
        <PageHeader
          title="About  ICAIM"
          crumbs={[
            { label: "Home", href: "/" },
            { label: "ICAIM 2027" },
          ]}
        />
      </div>

      <div className="icaim27-page-wrapper">

        {/* Section 1: About ICAIM */}
        <section className="icaim27-section" id="about">
          <div className="icaim27-container">
            <div className="icaim27-card">
              <div className="icaim27-split-layout">
                <div className="icaim27-split-text">
                  <h2 className="icaim27-section-heading">About ICAIM</h2>
                  <div className="icaim27-title-underline-left"></div>
                  <p>
                    The International Conference on Advances in Information Technology and Management (ICAIM) is an annual premier event where academicians, researchers, and industry professionals come together to discuss the latest advancements in technology and management. Organized by Thakur Institute of Management Studies, Career Development & Research, the conference fosters knowledge sharing and collaboration.
                  </p>
                  <p>
                    ICAIM provides a dynamic platform to present research papers, exchange innovative ideas, and explore the intersection of IT and sustainable practices across various sectors including healthcare, agriculture, and business management.
                  </p>
                </div>
                <div className="icaim27-split-image">
                  <div className="icaim27-image-frame frame-right">
                    <img src="/ICAIM/ICAIM2027/about/img7.jpg" alt="ICAIM Inauguration" className="icaim27-shadow-img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: About Institute */}
        <section className="icaim27-section" id="institute">
          <div className="icaim27-container">
            <div className="icaim27-split-layout icaim27-reverse-mobile">
              <div className="icaim27-split-image">
                <div className="icaim27-image-frame frame-left">
                  <img src="/ICAIM/ICAIM2027/about/img22.jpg" alt="TIMSCDR Building" className="icaim27-shadow-img" />
                </div>
              </div>
              <div className="icaim27-split-text relative-box">
                <div className="icaim27-dot-pattern top-right"></div>
                <h2 className="icaim27-section-heading">About The Institute</h2>
                <div className="icaim27-title-underline-left"></div>
                <p>
                  Thakur Institute of Management Studies, Career Development & Research (TIMSCDR) was established under the aegis of Thakur Educational Trust (TET) with a clear objective of providing quality technical education. The institute is approved by AICTE, Govt. of Maharashtra, and is affiliated to the University of Mumbai.
                </p>
                <p>
                  The institute continually strives to create an environment that nurtures holistic development, equipping students with the necessary skills to excel in the rapidly evolving IT industry.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section: Association */}
        <section className="icaim27-section icaim27-pt-0" id="association">
          <div className="icaim27-container">
            <h3 className="icaim27-section-heading icaim27-text-center">In Association With</h3>
            <div className="icaim27-title-underline-center"></div>
            <div className="icaim27-association-card">
              <div className="icaim27-logos-grid">
                <img src="/ICAIM/ICAIM2027/about/img25.jpg" alt="AMC" />
                <img src="/ICAIM/ICAIM2027/about/img26.jpg" alt="NCSH" />
                <img src="/ICAIM/ICAIM2027/about/img27.jpg" alt="GIST" />
                <img src="/ICAIM/ICAIM2027/about/img29.jpg" alt="DMI" />
                <img src="/ICAIM/ICAIM2027/about/img31.jpg" alt="MACCIA" />
              </div>
            </div>
          </div>
        </section>

        {/* Section 3: Theme */}
        <section className="icaim27-section" id="theme">
          <div className="icaim27-container">
            <div className="icaim27-theme-wrapper">
              <h2 className="icaim27-theme-main-title">Leveraging Information Technology for Sustainability in<br/>Agriculture and Healthcare</h2>
              <div className="icaim27-title-underline-center"></div>
              
              <div className="icaim27-theme-content-split">
                <div className="icaim27-theme-text-side">
                  <div className="icaim27-badge-pill">
                    {/* SVG Calendar Icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim27-icon-svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                    </svg>
                    Main Conference Theme - 2027
                  </div>
                  <p className="icaim27-theme-desc">
                    This conference aims to explore the multifaceted role of Information Technology in driving sustainable solutions within the crucial sectors of agriculture and healthcare. As global challenges mount, the integration of IoT, AI, data analytics, and mobile technologies becomes imperative for optimizing resource usage, improving crop yields, and enhancing patient care methodologies.
                  </p>
                </div>
                
                <div className="icaim27-theme-image-side">
                  <img src="/ICAIM/ICAIM2027/about/img45.jpg" alt="Conference Details" className="icaim27-brochure-img" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section: Speakers */}
        <section className="icaim27-section icaim27-pt-0" id="speakers">
          <div className="icaim27-container">
            <h3 className="icaim27-section-heading icaim27-text-center">Key Speakers</h3>
            <div className="icaim27-title-underline-center"></div>
            
            <div className="icaim27-speakers-grid">
              {[
                { name: "Dr. Ananda Fernandes", role: "KEYNOTE SPEAKER", isLight: false },
                { name: "Mrs. Ritu Bangia", role: "GUEST OF HONOR", isLight: true },
                { name: "Mr. Sunil Agrawal", role: "INDUSTRY EXPERT", isLight: true },
                { name: "Dr. Sangeeta Srivastava", role: "SESSION CHAIR", isLight: true }
              ].map((speaker, index) => (
                <div className="icaim27-speaker-card" key={index}>
                  {/* Removed Avatar SVG Block */}
                  <h4>{speaker.name}</h4>
                  <span className={`icaim27-badge ${speaker.isLight ? 'icaim27-badge-light' : ''}`}>{speaker.role}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section 4: Schedule */}
        <section className="icaim27-section" id="schedule">
          <div className="icaim27-container">
            <h2 className="icaim27-section-heading icaim27-text-center">Conference Schedule</h2>
            <div className="icaim27-title-underline-center"></div>
            
            <div className="icaim27-schedule-grid">
              <div className="icaim27-schedule-item">
                <img src="/ICAIM/ICAIM2027/about/img60.jpg" alt="Day 1 Schedule" className="icaim27-shadow-img" />
              </div>
              <div className="icaim27-schedule-item">
                <img src="/ICAIM/ICAIM2027/about/img62.jpg" alt="Day 2 Schedule" className="icaim27-shadow-img" />
              </div>
              <div className="icaim27-schedule-item">
                <img src="/ICAIM/ICAIM2027/about/img63.jpg" alt="Day 3 Schedule" className="icaim27-shadow-img" />
              </div>
            </div>
            
            {/* Gallery Carousel */}
            <h3 className="icaim27-section-heading icaim27-text-center" style={{ marginTop: '80px' }}>Gallery</h3>
            <div className="icaim27-title-underline-center"></div>
            
            <div className="icaim27-gallery-wrapper">
              <button className="icaim27-carousel-btn left">
                {/* SVG Left Arrow */}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
              </button>
              <div className="icaim27-schedule-grid gallery">
                 <div className="icaim27-schedule-item">
                  <img src="/ICAIM/ICAIM2027/about/img65.jpg" alt="Gallery 1" className="icaim27-shadow-img" />
                </div>
                 <div className="icaim27-schedule-item">
                  <img src="/ICAIM/ICAIM2027/about/img66.jpg" alt="Gallery 2" className="icaim27-shadow-img" />
                </div>
                 <div className="icaim27-schedule-item">
                  <img src="/ICAIM/ICAIM2027/about/img67.jpg" alt="Gallery 3" className="icaim27-shadow-img" />
                </div>
              </div>
              <button className="icaim27-carousel-btn right">
                {/* SVG Right Arrow */}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              </button>
            </div>
            
            <div className="icaim27-carousel-dots">
              <span className="dot active"></span>
              <span className="dot"></span>
            </div>
            
            {/* Footer Logos */}
            <div className="icaim27-logos-grid footer-logos" style={{ marginTop: '60px' }}>
                <img src="/ICAIM/ICAIM2027/about/img79.jpg" alt="ADR" />
                <img src="/ICAIM/ICAIM2027/about/img80.jpg" alt="ESN Publications" />
                <img src="/ICAIM/ICAIM2027/about/img81.jpg" alt="ESJI" />
            </div>

          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default Icaim27;